import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { IStepFields } from "../../../../interface/MedicalRecord";
import { FieldRenderer } from "../FieldRenderer/FieldRenderer";
import { MedicalFields } from "../../../../enums/MedicalReportEnums";
import StatisticChild from "./StatisticChild";

interface RepeatableSectionProps {
  field: IStepFields | any;
  disabled?: boolean;
}

const RepeatableSection: React.FC<RepeatableSectionProps> = ({
  field,
  disabled = false,
}) => {
  const methods = useFormContext();

  const name = `Attributes.${field.Id}`;

  const values = methods.watch(name);

  const [count, setCount] = useState<number>(
    Array.isArray(values) ? values.length : 0
  );

  useEffect(() => {
    if (Array.isArray(values)) {
      setCount(values.length);
    }
  }, [values]);

  const handleCountChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newCount = Math.max(
      0,
      Number(event.target.value) || 0
    );

    const currentValues = methods.getValues(name);

    const currentArray = Array.isArray(currentValues)
      ? currentValues
      : [];

    const nextArray = Array.from(
      { length: newCount },
      (_, index) => currentArray[index] ?? {}
    );

    

    setCount(newCount);

    methods.setValue(name, nextArray, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };


  const removeKeys = (children: any[]): any[] =>
    children.map((child) => ({
      ...child,
      Key: undefined,
      InverseParentStepFields: removeKeys(
        child.InverseParentStepFields ?? []
      ),
    }));

  const children = removeKeys(
    field?.InverseParentStepFields ?? []
  );


  const repeatedChildren = children?.filter(
    (item) => item?.Type !== MedicalFields.Statistics
  );


  const statisticChildren =
    field?.InverseParentStepFields?.filter(
      (item: any) => item?.Type === MedicalFields.Statistics
    );

  return (
    <div className="w-full space-y-4 pt-4">
      <div className="w-full">
        <label className="mb-2 block text-sm font-medium text-primary-text">
          {field?.Name}
        </label>

        <input
          type="number"
          min={0}
          value={count}
          placeholder={field?.Name}
          disabled={disabled}
          onChange={handleCountChange}
          className="
            placeholder:!text-text-muted
            w-full
            appearance-none
            rounded-lg
            h-14
            min-w-60
            border
            border-systemBg
            px-4
            py-2
            text-base
            text-primary-text
            placeholder-body-text
            focus:!border-primary
            focus:bg-white
            focus:outline-none
            bg-white
          "
        />
      </div>

      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="
            w-full
            rounded-lg
            border
            border-gray-200
            bg-primary-bg
            p-4
            space-y-4
          "
        >
          <h3 className="font-semibold text-primary-text">
            {t("number")} #{index + 1}
          </h3>

          <div className="grid grid-cols-1 gap-4">
            {repeatedChildren.map(
              (child: IStepFields) => {
               
                const childName =
                  `${name}.${index}.${child.Id}`;

                return (
                  <FieldRenderer
                    key={child.Id}
                    disabled={disabled}
                    field={{
                      ...child,
                      Key: childName,
                      ParentName: `${name}.${index}`,
                    }}
                  />
                );
              }
            )}
          </div>
        </div>
      ))}

      <div className="grid grid-cols-1 gap-4">
        {statisticChildren?.map(
          (child: IStepFields) => (
            <StatisticChild
              key={child.Id}
              field={field}
              child={child}
            />
          )
        )}
      </div>
    </div>
  );
};

export default RepeatableSection;